import { ONE_SECOND } from 'constants'

export const data = {
    event_config: {
        visible_start_date: Date.now() + (ONE_SECOND * 10),
        visible_end_date: Date.now() + (ONE_SECOND * 300000),
        name: 'Манёвры',
    },
}



// WEBPACK FOOTER //
// ./state/__mocks__/stronghold_maneuvers_mock.js